require('./accountChequebookMovements.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const AccountChequebookMovementsContent = require('./accountChequebookMovementsContent/accountChequebookMovementsContent');

class AccountChequebookMovements extends React.Component {
    constructor(props) {
        super(props);

        this.handleApplyFilter = this.handleApplyFilter.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    handleApplyFilter(selected) {
        const { accountId, setAccountChequebookFilter, immCheques, chequebookIndex, requestChequebook } = this.props;

        if (selected.value !== immCheques.get('chequebookFilter')) {
            setAccountChequebookFilter(selected.value, accountId);
            requestChequebook(accountId, chequebookIndex);
        }
    }

    render() {
        const { immCheques, chequebookIndex, accountId } = this.props;
        let content;

        if (immCheques && !immCheques.get('loading') && !immCheques.get('error')) {
            content = (
                <AccountChequebookMovementsContent
                    onFilterSelect={this.handleApplyFilter}
                    immCheques={immCheques}
                    chequebookIndex={chequebookIndex}
                    accountId={accountId}
                />
            );
        } else {
            content = <LoadingSection />;
        }

        return (
            <div className="account-chequebook-movements">
                {content}
            </div>
        )
    }
}

AccountChequebookMovements.propTypes = {
    immCheques: PropTypes.object,
    accountId: PropTypes.string.isRequired,
    chequebookIndex: PropTypes.string.isRequired,
    requestChequebook: PropTypes.func.isRequired,
    setAccountChequebookFilter: PropTypes.func.isRequired
};

module.exports = AccountChequebookMovements;